// Shared by world.ts and levels.ts
export const K = 'socks';
export const DEG = Math.PI / 180;
